var map = {
	"./Ginetex-Symbols.ttf": 89227,
	"./Gotham-Bold.ttf": 9058,
	"./Gotham-BoldItalic.ttf": 63182,
	"./Gotham-Italic.ttf": 93686,
	"./Gotham.ttf": 29850,
	"./wash_care_symbol.ttf": 38434,
	"./wash_care_symbols.ttf": 33151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54648;